export default __webpack_public_path__ + "static/logo-desktop-d78e313038b8e9973a12b0ba7df6ce09.png";